import { duration } from '../utils/duration';

// Depend on invite sub feature we may change behavior of invite feature
// For example: invite_no_energy will re place 10 gems to one energy
// Other will be used just for analytics sub feature
export type SocialSubFeature =
  | 'visit_no_friends_invite'
  | 'invite_icon'
  | 'invite_icon_energy_gift'
  | 'invite_gems_icon'
  | 'invite_launch'
  | 'invite_unlock'
  | 'invite_low_balance'
  | 'invite_instead_gems_shop'
  | 'invite_no_energy'
  | 'invite_wallpaper_reward'
  | 'invite_event_energy'
  | 'invite_friends_toast'
  // Invite celebration subfeatures
  | 'invite_new_pet'
  | 'invite_pet_evolve'
  | 'invite_match_level'
  | 'continue_social'
  | 'time_pressure_invite'
  | 'friends_search_players'
  | 'invite_buddies';

export type InviteRewardType = 'gems' | 'energy' | 'moves';

// Sported reward types
export type ReferralRewardType = 'gems';
// Reward type, we support only gems for now
export type ReferralReward = { type: ReferralRewardType; value: number };

export type InviteChallengeWallpapers =
  (typeof inviteChallengeWallpapers)[number];

export const inviteFriendListLimit = 100;

export const inviteFriendListSelectionLimit = 10;

export const recentInviteDuration = duration({ days: 30 });

export const inviteRewardGems = 10;
export const successInviteRewardGems = 50;
export const inviteRewardEnergy = 5;

export const minigamesToUnlockInvite = 1;
// Wallpaper challenge
export const inviteChallengeTarget = 10;
export const inviteChallengeDuration = duration({ hours: 24 });
export const inviteChallengeWallpapers = ['kingkong'] as const;

// Social Continue
export const minFriendsForSocialContinue = 1;
export const maxSocialContinueRewardMoves = 5;
export const socialContinueCooldown = duration({ hours: 6 });
export const inviteRewardMoves = 1;
